
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5737',
  depVersions: {
  "data-privacy-request-ui": "static-1.5737",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9878",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8245",
  "hub-http-shared-msw-handlers": "static-1.10483",
  "hubspot-dlb": "static-2.1877",
  "HubStyleTokens": "static-2.11702",
  "I18n": "static-7.1652",
  "jasmine-runner": "static-1.6670",
  "quartz": "static-1.7328",
  "react-dlb": "static-1.84",
  "rpc-client-utils": "static-1.4883",
  "ui-components-test-utils": "static-1.5839",
  "UIComponents": "static-3.8648",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.89",
  "foundations-assets": "static-1.5096",
  "foundations-components": "static-1.8345",
  "foundations-components-test-utils": "static-1.5828",
  "foundations-theming": "static-1.4671",
  "hub-http": "static-1.6435",
  "quartz-config": "static-1.1106",
  "quartz-core": "static-1.6547",
  "quartz-routing": "static-1.758",
  "quick-fetch": "static-1.4071",
  "raven": "static-3.5925",
  "react": "static-7.190",
  "react-rhumb": "static-1-redact-emails-from-unexpected-route-pathname.6",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11367",
  "usage-tracker": "static-1.7577",
  "usage-tracker-anonymous": "static-1.5994",
  "usage-tracker-core": "static-1.7427",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4282",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9849",
  "react-redux": "static-7.75",
  "redux": "static-4.16",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3554",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3605",
  "quartz-webpack": "static-1.3552",
  "bend-plugin-quartz-routing": "static-1.406",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3356",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "ts-schema": "static-1.4232",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "react-utils": "static-2.5495",
  "StyleGuideUI": "static-3.492",
  "jasmine": "static-4.4540",
  "bend-plugin-chirp-manifest": "static-1.293",
  "chirp-fetch": "static-1.2109",
  "HubStyle": "static-2.12009",
  "ui-addon-draggable": "static-3.4976",
  "cssUtils": "static-1.857",
  "hs-story-utils": "static-1.9646",
  "icons": "static-2.671",
  "react-create-root-preference": "static-1.52",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.103",
  "ui-images": "static-2.1219",
  "bend-plugin-foundations-components": "static-1.4614",
  "floating-ui": "static-1.60",
  "foundations-theming-specialty": "static-1.2387",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2394",
  "ui-fonts": "static-1.964",
  "foundations-components-legacy": "static-1.1370",
  "bend-plugin-foundations-theming": "static-1.3154",
  "foundations-theming-base": "static-1.3656",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.234",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.860",
  "hubspotter-http": "static-1.4803",
  "mobile-manifest-mixins": "static-1.557",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1003",
  "quartz-head": "static-1.993",
  "quartz-i18n": "static-1.1003",
  "quartz-test": "static-1.1003",
  "quartz-tracking": "static-1.707",
  "trellis-components": "static-1.2413",
  "usage-tracker-container": "static-1.7567",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3347",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.74",
  "sassPrefix": "static-1.161",
  "hubspotter-http-shared-msw-handlers": "static-1.10481",
  "usage-tracker-session-replay": "static-1.5263",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1175",
  "tanstack-virtual": "static-1.35",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5737",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9878",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8245",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10483",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "HubStyleTokens": "/HubStyleTokens/static-2.11702",
  "I18n": "/I18n/static-7.1652",
  "jasmine-runner": "/jasmine-runner/static-1.6670",
  "quartz": "/quartz/static-1.7328",
  "react-dlb": "/react-dlb/static-1.84",
  "rpc-client-utils": "/rpc-client-utils/static-1.4883",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5839",
  "UIComponents": "/UIComponents/static-3.8648",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "foundations-assets": "/foundations-assets/static-1.5096",
  "foundations-components": "/foundations-components/static-1.8345",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5828",
  "foundations-theming": "/foundations-theming/static-1.4671",
  "hub-http": "/hub-http/static-1.6435",
  "quartz-config": "/quartz-config/static-1.1106",
  "quartz-core": "/quartz-core/static-1.6547",
  "quartz-routing": "/quartz-routing/static-1.758",
  "quick-fetch": "/quick-fetch/static-1.4071",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.190",
  "react-rhumb": "/react-rhumb/static-1-redact-emails-from-unexpected-route-pathname.6",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11367",
  "usage-tracker": "/usage-tracker/static-1.7577",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5994",
  "usage-tracker-core": "/usage-tracker-core/static-1.7427",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9849",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3554",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3605",
  "quartz-webpack": "/quartz-webpack/static-1.3552",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.406",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3356",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "ts-schema": "/ts-schema/static-1.4232",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "react-utils": "/react-utils/static-2.5495",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "jasmine": "/jasmine/static-4.4540",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.293",
  "chirp-fetch": "/chirp-fetch/static-1.2109",
  "HubStyle": "/HubStyle/static-2.12009",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4976",
  "cssUtils": "/cssUtils/static-1.857",
  "hs-story-utils": "/hs-story-utils/static-1.9646",
  "icons": "/icons/static-2.671",
  "react-create-root-preference": "/react-create-root-preference/static-1.52",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.103",
  "ui-images": "/ui-images/static-2.1219",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4614",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2387",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2394",
  "ui-fonts": "/ui-fonts/static-1.964",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1370",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3154",
  "foundations-theming-base": "/foundations-theming-base/static-1.3656",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.234",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.860",
  "hubspotter-http": "/hubspotter-http/static-1.4803",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.557",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1003",
  "quartz-head": "/quartz-head/static-1.993",
  "quartz-i18n": "/quartz-i18n/static-1.1003",
  "quartz-test": "/quartz-test/static-1.1003",
  "quartz-tracking": "/quartz-tracking/static-1.707",
  "trellis-components": "/trellis-components/static-1.2413",
  "usage-tracker-container": "/usage-tracker-container/static-1.7567",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3347",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.74",
  "sassPrefix": "/sassPrefix/static-1.161",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10481",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5263",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1175",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
